function setMemberships(data) {
	return {
		type: 'SET_MEMBERSHIPS',
		payload: data,
	};
}

export { setMemberships };
